<template>
    <div>
        <template v-if="hasRequiredDocuments">
            <h4>Obligātie dokumenti</h4>
            <div class="row d-flex align-items-stretch mt-4">
                <div v-for="(category, i) in userData.requiredDocuments" :key="`user-category-${i}`" class="col-sm-4 mb-4">
                    <div class="border shadow-sm p-3 h-100">
                        <template v-if="category.requiredDocuments.length">
                            <p class="text-center font-weight-bolder">{{ category.name }}</p>
                            <div v-for="(requiredDocument) in category.requiredDocuments" :key="`required-user-document-${requiredDocument._id}`" class="mb-2">
                                <template v-if="currentUser.isUser">
                                    <font-awesome-icon v-if="hasPassed(requiredDocument.documentForm)" icon="check-circle" class="ds-btn--icon-green"/>
                                    <font-awesome-icon v-else icon="times-circle" class="ds-btn--icon-red"/>
                                </template>
                                <router-link :to="{name: 'single-document-view', params: {documentId: requiredDocument._id}}" class="ml-2 text-dark">
                                    {{ requiredDocument.name }}
                                </router-link>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="hasOptionalDocuments">
            <hr class="my-4"/>
            <h4>Papildus dokumenti</h4>
            <div class="row d-flex align-items-stretch mt-4">
                <div v-for="(category, i) in userData.optionalDocuments" :key="`user-category-${i}`" class="col-sm-4 mb-4">
                    <template v-if="category.optionalDocuments.length">
                        <div class="border shadow-sm p-3 h-100">
                            <p class="text-center font-weight-bolder">{{ category.name }}</p>
                            <div v-for="(optionalDocument, j) in category.optionalDocuments" :key="`optional-user-document-${j}`" class="mb-2">
                                <font-awesome-icon icon="info-circle" class="ds-btn--icon-grey"/>
                                <router-link :to="{name: 'single-document-view', params: {documentId: optionalDocument._id}}" class="ml-2 text-dark">
                                    {{ optionalDocument.name }}
                                </router-link>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </template>
        <template v-if="!hasRequiredDocuments && !hasOptionalDocuments">
            <h4>Nav nevienas pieejamas kategorijas šai lietotāju grupai!</h4>
        </template>
    </div>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex';

    import * as userStoreTypes from '../../vuex/modules/user/user.store-types';
    import * as authStoreTypes from '../../vuex/modules/auth/auth.store-types';

    export default {
        name: 'user-categories-list',
        async created() {
            await this.getUserData({companyId: this.currentUser.company._id, userId: this.currentUser.userId});
        },
        computed: {
            ...mapGetters('auth', {
                /** @type {CurrentUser|*} */
                currentUser: authStoreTypes.GET_CURRENT_USER,
            }),
            ...mapGetters('user', {
                /** @type {array|*} */
                userData: userStoreTypes.GET_USER_DATA,
            }),
            hasRequiredDocuments() {
                return this.userData.requiredDocuments && this.userData.requiredDocuments.length;
            },
            hasOptionalDocuments() {
                return this.userData.optionalDocuments && this.userData.optionalDocuments.length;
            }
        },
        methods: {
            ...mapActions('user', {
                /** @type {function|*} */
                getUserData: userStoreTypes.ACTION_GET_USER_DATA,
            }),
            hasPassed: documentForm => documentForm.documentFormResults?.some(result => result.isPassed)
        }
    }
</script>